export const SET_ADMISSIONS = 'SET_ADMISSIONS';
export const SET_ADMISSION = 'SET_ADMISSION';
export const DELETE_ADMISSION = 'DELETE_ADMISSION';
export const RESET = 'RESET';
export const SET_SOCKET_ONLINE = 'SET_SOCKET_ONLINE';
export const SET_SOCKET_OFFLINE = 'SET_SOCKET_OFFLINE';
